module.exports = __webpack_public_path__ + "static/shoes-color-set-2-c150c13e9252db945f1c26c2b5af6f61.png";